// extracted by mini-css-extract-plugin
export default {"reportBtn":"donwloadReportButton_reportBtn__iYe0e","mobileLabel":"donwloadReportButton_mobileLabel__IGPrr","desktopLabel":"donwloadReportButton_desktopLabel__JB6zW"};